const RecruiterStats = ({ stats }) => (
  <div className="staff-metrics" style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))' }}>
    <div className="staff-metric">
      <span className="staff-metric-label">Placements</span>
      <span className="staff-metric-value">{stats.placements || 0}</span>
    </div>
    <div className="staff-metric">
      <span className="staff-metric-label">Candidates</span>
      <span className="staff-metric-value">{stats.students || 0}</span>
    </div>
  </div>
);

export default RecruiterStats;
